import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export type ConnectionQuality = 'good' | 'poor' | 'unknown';

@Injectable({
    providedIn: 'root'
})
export class NetworkService {

    public online$ = new BehaviorSubject<boolean>(navigator.onLine);
    public quality$ = new BehaviorSubject<ConnectionQuality>('unknown');

    constructor(private ngZone: NgZone) {
        window.addEventListener('online', () => this.ngZone.run(() => this.online$.next(true)));
        window.addEventListener('offline', () => this.ngZone.run(() => this.online$.next(false)));

        const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
        if (connection) {
            const updateQuality = () => this.ngZone.run(() => this.quality$.next(this.determineQuality(connection)));
            updateQuality();
            connection.addEventListener('change', updateQuality);
        }
    }

    private determineQuality(connection: any): ConnectionQuality {
        if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
            return 'poor';
        }
        if (typeof connection.downlink === 'number' && connection.downlink < 1) {
            return 'poor';
        }
        return 'good';
    }
}
